import React from 'react';
import { Label } from 'app/components/ui/label';
import { Switch } from 'app/components/ui/switch';

interface SwitchFieldProps {
  label: string;
  description: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
}

export const SwitchField: React.FC<SwitchFieldProps> = ({
  label,
  description,
  checked,
  onChange,
  className = '',
}) => {
  return (
    <div className={`flex items-center justify-between ${className}`}>
      <div className="space-y-0.5">
        <Label className="text-sm font-medium text-gray-800 dark:text-gray-200">
          {label}
        </Label>
        <p className="text-xs text-gray-500 dark:text-gray-400">
          {description}
        </p>
      </div>
      <Switch checked={checked} onCheckedChange={onChange} />
    </div>
  );
};

export default SwitchField;
